<template>
    <div id="app">

        <Splash />

        <div class="contain-top-widgets cc-txt-center columns">
            <Clock />
            <GoogleInsight />
            <Compta />
        </div>

        <Phone />
        <Nagios />

    </div>
</template>

<script>
    import Clock from './components/Clock.vue'
    import Splash from './components/Splash.vue'
    import Compta from './components/Compta.vue'
    import Nagios from './components/Nagios.vue'
    import GoogleInsight from './components/GoogleInsight.vue'
    import News from './components/News.vue'
    import axios from 'axios';
    import Phone from "./components/Phone";

    export default {
        name: 'app',
        components: {
          Phone,
            Clock, Nagios, Splash, GoogleInsight, News, Compta
        },
        data() {
            return {
                checkUri: 'http://dashboard.alpixel.fr/deployment_token',
                deploymentToken: null,
            };
        },
        created() {
            axios.get(this.checkUri).then(response => {
                this.deploymentToken = response.data;
            });
            setInterval(() => this.checkFresh(), 60 * 1000);
        },
        methods: {
            checkFresh() {
                if (this.checkUri != null) {
                    axios.get(this.checkUri + "?" + Date.now()).then(response => {
                        if (response.data != this.deploymentToken)
                            document.location.reload();
                    });
                }
            },
        }
    }
</script>

<style lang="less">
    @import "~@fortawesome/fontawesome-free/css/all.min.css";
    @import "~ChuckCSS/chuckcss/front";

    @loader-bg: white;

    body {
        background-color:#121212;
        height:100vh;
        width:100vw;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        overflow:hidden;
        padding: 2em;
    }

    .contain-top-widgets {
        & > div {
            color: #fff;
            display: flex;
            padding:20px;
        }
    }



</style>
